const LOGO_URL = "https://customer-assets-7cd3h4nn.emergentagent.net/job_court-radar-preview/artifacts/nx2smc2j_image.png";

export default function Logo({ className = "", light = false, size = 34 }) {
  return (
    <div className={`inline-flex items-center gap-2 ${className}`} data-testid="pv-logo">
      <div
        className="rounded-xl grid place-items-center overflow-hidden"
        style={{ width: size + 8, height: size + 8, background: light ? "#F8F6F3" : "transparent" }}
      >
        <img src={LOGO_URL} alt="PaddleVerse" style={{ width: size + 4, height: "auto" }} />
      </div>
      <span
        className="font-display font-extrabold tracking-tight"
        style={{ color: light ? "#FFFFFF" : "#0E395F", fontSize: size * 0.6 }}
      >
        The Paddle<span style={{ color: light ? "#BED445" : "#0E395F" }}>Verse</span>
      </span>
    </div>
  );
}
